import { Box } from "@chakra-ui/react";
import { DetailsForm } from "./detailsForm";

export const Main = () => {
  return (
    <>
      <Box w={"75%"} px={"10"}>
        <DetailsForm />
      </Box>
    </>
  );
};
